import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3eb46e54"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "taskList__box"
};
const _hoisted_2 = {
  key: 0
};
import { ref, watch, nextTick } from 'vue'; // eslint-disable-next-line

export default {
  __name: 'taskList',
  props: {
    tasklist: {
      type: Array,
      default: () => []
    }
  },
  emits: ['deleteTask', 'markTask', 'editTask', 'updateTask', 'blurTask', 'clickNodata'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const editInput = ref(null);
    const swipeCell = ref(null);
    let open = ref(0);
    let editKey = ref(null); // eslint-disable-next-line

    const deleteTaskItem = key => {
      emit('deleteTask', key);
    };

    const checkedTask = key => {
      emit('markTask', key);
    };

    function editTaskItem(key) {
      open.value = 1;
      editKey = key;
      emit('editTask', key);
    }

    function updateTaskItem(value) {
      emit('updateTask', value, editKey);
    }

    watch(open, newValue => {
      if (newValue === 1) {
        nextTick(() => {
          setTimeout(() => {
            editInput.value[editKey].focus();
          }, 500);
        });
      }
    });

    function closeCell() {
      open.value = 0;
    }

    function blurInput() {
      open.value = 0;
      emit('blurTask');
    }

    function clickNoDataItem() {
      emit('clickNodata');
    }

    return (_ctx, _cache) => {
      const _component_van_cell = _resolveComponent("van-cell");

      const _component_van_field = _resolveComponent("van-field");

      const _component_van_button = _resolveComponent("van-button");

      const _component_van_swipe_cell = _resolveComponent("van-swipe-cell");

      const _component_van_cell_group = _resolveComponent("van-cell-group");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_cell_group, {
        inset: "",
        title: "任务列表"
      }, {
        default: _withCtx(() => [props.tasklist.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tasklist, item => {
          return _openBlock(), _createElementBlock("div", {
            class: "cell__box",
            key: item.key
          }, [_createVNode(_component_van_swipe_cell, {
            class: _normalizeClass(item.checked ? 'cell__checked' : ''),
            ref_for: true,
            ref_key: "swipeCell",
            ref: swipeCell,
            onClose: closeCell
          }, {
            left: _withCtx(() => [_createVNode(_component_van_button, {
              square: "",
              type: "primary",
              disabled: item.checked,
              text: "编辑",
              onClick: $event => editTaskItem(item.key)
            }, null, 8, ["disabled", "onClick"])]),
            right: _withCtx(() => [_createVNode(_component_van_button, {
              square: "",
              type: "primary",
              text: item.checked ? '取消完成' : '已完成',
              onClick: $event => checkedTask(item.key)
            }, null, 8, ["text", "onClick"]), _createVNode(_component_van_button, {
              square: "",
              type: "danger",
              text: "删除",
              onClick: $event => deleteTaskItem(item.key)
            }, null, 8, ["onClick"])]),
            default: _withCtx(() => [_withDirectives(_createVNode(_component_van_cell, {
              value: item.text
            }, null, 8, ["value"]), [[_vShow, !item.isEdit]]), _withDirectives(_createVNode(_component_van_field, {
              onBlur: blurInput,
              "onUpdate:modelValue": [updateTaskItem, $event => item.text = $event],
              ref_for: true,
              ref_key: "editInput",
              ref: editInput,
              modelValue: item.text,
              placeholder: "请输入任务项"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]), [[_vShow, item.isEdit]])]),
            _: 2
          }, 1032, ["class"])]);
        }), 128))])) : _createCommentVNode("", true), !props.tasklist.length ? (_openBlock(), _createBlock(_component_van_cell_group, {
          key: 1,
          inset: "",
          onClick: clickNoDataItem
        }, {
          default: _withCtx(() => [_createVNode(_component_van_cell, {
            value: "还没有任务, 添加一个吧~",
            class: "notask"
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })]);
    };
  }

};